function updateGridLayout(containerSelector, wrapSelector) {
  const wraps = document.querySelectorAll(wrapSelector);
  const gridContainer = document.querySelector(containerSelector); 

  function applyGridLayout() {
    const activeWrap = document.querySelector(`${wrapSelector}.active`);
    if (!activeWrap) return;

    const viewedByValue = activeWrap.getAttribute('data-viewed-by');
    const currentClasses = gridContainer.className;

    gridContainer.className = currentClasses
      .replace(/grid--\d-col-desktop/, '')
      .trim();
    
    if (viewedByValue === '3') {
      gridContainer.classList.add('grid--3-col-desktop');
    } else if (viewedByValue === '4') {
      gridContainer.classList.add('grid--4-col-desktop');
    } else if (viewedByValue === '5') {
      gridContainer.classList.add('grid--5-col-desktop');
    } else if (viewedByValue === '6') {
      gridContainer.classList.add('grid--6-col-desktop');
    }
  }

  wraps.forEach(wrap => {
    wrap.addEventListener('click', function() {
      wraps.forEach(w => w.classList.remove('active')); 
      this.classList.add('active');
      applyGridLayout();
    });
  });

  window.addEventListener('popstate', applyGridLayout);
  window.addEventListener('hashchange', applyGridLayout);

  applyGridLayout();
}

updateGridLayout('.grid-container', '.wrap-selector');

function initializeViewBySwitcher() {
    const items = document.querySelectorAll('.mobile-view-by-content');
    const productGrid = document.querySelector('#product-grid');

    // Ensure that the #product-grid element exists
    if (!productGrid) {
        console.error("Product grid element (#product-grid) not found.");
        return;
    }

    items.forEach((item) => {
        item.addEventListener('click', function() {
            items.forEach((el) => {
                el.classList.remove('active');
            });
            this.classList.add('active');

            const viewedBy = this.getAttribute('data-viewed-by');

            if (viewedBy === "2") {
                if (!productGrid.classList.contains('grid--2-col-tablet-down')) {
                    productGrid.classList.add('grid--2-col-tablet-down');
                }
                productGrid.classList.remove('grid--1-col-tablet-down');
            } else if (viewedBy === "1") {
                if (!productGrid.classList.contains('grid--1-col-tablet-down')) {
                    productGrid.classList.add('grid--1-col-tablet-down');
                }
                productGrid.classList.remove('grid--2-col-tablet-down');
            } 
        });
    });
}



document.addEventListener('DOMContentLoaded', function() {
  updateGridLayout('.grid.product-grid', '.desktop-view-by-wrap span[data-viewed-by]');
  initializeViewBySwitcher();
});

